import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "tv-dialog" };
const _hoisted_2 = { class: "tv-header" };
const _hoisted_3 = {
    key: 0,
    class: "tv-body"
};
const _hoisted_4 = { class: "tv-hero" };
const _hoisted_5 = ["src"];
const _hoisted_6 = { class: "tv-merchant" };
const _hoisted_7 = { class: "tv-details" };
const _hoisted_8 = { class: "tv-row" };
const _hoisted_9 = { class: "tv-value" };
const _hoisted_10 = {
    key: 0,
    class: "tv-row"
};
const _hoisted_11 = { class: "tv-value" };
const _hoisted_12 = { class: "tv-row" };
const _hoisted_13 = { class: "tv-value" };
const _hoisted_14 = { class: "tv-row" };
const _hoisted_15 = { class: "tv-value" };
const _hoisted_16 = {
    key: 1,
    class: "tv-row"
};
const _hoisted_17 = { class: "tv-value" };
import { ref, computed, getCurrentInstance } from 'vue';
import CategoryLozenge from '@/components/elements/CategoryLozenge.vue';
import { useAppState } from '@/composables/useAppState';
import { useTransactions } from '@/composables/useTransactions';
import { getMerchantLogoUrl, getMerchantLogoStyle, onMerchantLogoError, isWellKnownLogosOnly } from '@/utils/helpers';
export default /*@__PURE__*/ _defineComponent({
    __name: 'TransactionViewDialog',
    props: {
        transaction: {}
    },
    emits: ["change-category"],
    setup(__props, { expose: __expose, emit: __emit }) {
        const props = __props;
        const emit = __emit;
        const state = useAppState();
        const transactionsApi = useTransactions();
        const wellKnownLogosOnlyGlobal = getCurrentInstance()?.appContext.config.globalProperties.$wellKnownLogosOnly;
        const isOpen = ref(false);
        // The spending-analysis transaction shape lacks account / description / exclude,
        // so fetch the full transaction on open and prefer it once it lands.
        const fullTxn = ref(null);
        const tx = computed(() => fullTxn.value ?? props.transaction);
        const merchantName = computed(() => tx.value?.merchant?.name ?? tx.value?.merchantName ?? '');
        const isIncome = computed(() => (tx.value?.amount ?? 0) > 0);
        const amountDisplay = computed(() => {
            const amt = tx.value?.amount ?? 0;
            const formatted = state.formatter.format(Math.abs(amt));
            return isIncome.value ? '+' + formatted : formatted;
        });
        const categoryName = computed(() => {
            const c = tx.value?.effectiveClassification;
            return c?.mgSubClassification || c?.mgClassification || 'Uncategorised';
        });
        const dateDisplay = computed(() => {
            const ts = tx.value?.timestamp;
            if (!ts)
                return '';
            return new Date(ts).toLocaleDateString('en-GB', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });
        });
        const accountDisplay = computed(() => {
            const id = tx.value?.bankAccountID;
            if (!id)
                return '';
            const account = (state.bankInfo?.accounts ?? []).find((a) => a.id === id);
            if (!account)
                return '';
            return account.bank?.prettyName ?? account.bank?.name ?? account.bankDisplayName ?? '';
        });
        const spendingAnalysisDisplay = computed(() => (tx.value?.excludeFromAnalysis ? 'Excluded' : 'Included'));
        const descriptionDisplay = computed(() => tx.value?.description ?? '');
        const logoInput = computed(() => ({
            name: merchantName.value,
            wellKnown: !!tx.value?.merchant || tx.value?.wellKnownMerchant === true,
            iconPath: tx.value?.effectiveClassification?.iconPath,
            iconColour: tx.value?.effectiveClassification?.color,
            wellKnownLogosOnly: isWellKnownLogosOnly(wellKnownLogosOnlyGlobal),
        }));
        const logoUrl = computed(() => tx.value?.merchant?.logoUrl ?? getMerchantLogoUrl(logoInput.value));
        const logoStyle = computed(() => getMerchantLogoStyle(logoInput.value));
        const avatarIsCategory = computed(() => !!logoStyle.value.backgroundColor);
        function onLogoError(e) { onMerchantLogoError(e, logoInput.value); }
        function openDrawer() {
            fullTxn.value = null;
            isOpen.value = true;
            const id = props.transaction?.id;
            if (id) {
                transactionsApi.getTransaction(id, (t) => {
                    if (props.transaction?.id === id)
                        fullTxn.value = t;
                });
            }
        }
        function closeDrawer() { isOpen.value = false; }
        __expose({ openDrawer, closeDrawer });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_dialog = _resolveComponent("v-dialog");
            return (_openBlock(), _createBlock(_component_v_dialog, {
                "model-value": isOpen.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => (isOpen.value = $event)),
                "max-width": "460",
                scrim: "rgba(0, 0, 0, 0.5)"
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, [
                            _cache[3] || (_cache[3] = _createElementVNode("h3", { class: "tv-title" }, "Transaction", -1)),
                            _createElementVNode("button", {
                                class: "tv-close",
                                onClick: closeDrawer
                            }, [
                                _createVNode(_component_v_icon, { size: "18" }, {
                                    default: _withCtx(() => _cache[2] || (_cache[2] = [
                                        _createTextVNode("mdi-close")
                                    ])),
                                    _: 1
                                })
                            ])
                        ]),
                        (_ctx.transaction)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                                _createElementVNode("div", _hoisted_4, [
                                    _createElementVNode("div", {
                                        class: "tv-avatar",
                                        style: _normalizeStyle({ backgroundColor: logoStyle.value.backgroundColor })
                                    }, [
                                        _createElementVNode("img", {
                                            class: _normalizeClass(avatarIsCategory.value ? 'tv-avatar-icon' : 'tv-avatar-logo'),
                                            src: logoUrl.value,
                                            onError: onLogoError,
                                            alt: ""
                                        }, null, 42, _hoisted_5)
                                    ], 4),
                                    _createElementVNode("div", _hoisted_6, _toDisplayString(merchantName.value), 1),
                                    _createElementVNode("div", {
                                        class: _normalizeClass(["tv-amount", { 'tv-amount-in': isIncome.value }])
                                    }, _toDisplayString(amountDisplay.value), 3)
                                ]),
                                _createVNode(CategoryLozenge, {
                                    categoryName: categoryName.value,
                                    iconPath: _ctx.transaction.effectiveClassification?.iconPath,
                                    iconColour: _ctx.transaction.effectiveClassification?.color,
                                    onClick: _cache[0] || (_cache[0] = ($event) => (emit('change-category')))
                                }, null, 8, ["categoryName", "iconPath", "iconColour"]),
                                _createElementVNode("div", _hoisted_7, [
                                    _createElementVNode("div", _hoisted_8, [
                                        _cache[4] || (_cache[4] = _createElementVNode("span", { class: "tv-label" }, "Date", -1)),
                                        _createElementVNode("span", _hoisted_9, _toDisplayString(dateDisplay.value), 1)
                                    ]),
                                    (accountDisplay.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                                            _cache[5] || (_cache[5] = _createElementVNode("span", { class: "tv-label" }, "Account", -1)),
                                            _createElementVNode("span", _hoisted_11, _toDisplayString(accountDisplay.value), 1)
                                        ]))
                                        : _createCommentVNode("", true),
                                    _createElementVNode("div", _hoisted_12, [
                                        _cache[6] || (_cache[6] = _createElementVNode("span", { class: "tv-label" }, "Transaction", -1)),
                                        _createElementVNode("span", _hoisted_13, _toDisplayString(isIncome.value ? 'Money in' : 'Money out'), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_14, [
                                        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "tv-label" }, "Spending Analysis", -1)),
                                        _createElementVNode("span", _hoisted_15, _toDisplayString(spendingAnalysisDisplay.value), 1)
                                    ]),
                                    (descriptionDisplay.value)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                            _cache[8] || (_cache[8] = _createElementVNode("span", { class: "tv-label" }, "Description", -1)),
                                            _createElementVNode("span", _hoisted_17, _toDisplayString(descriptionDisplay.value), 1)
                                        ]))
                                        : _createCommentVNode("", true)
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ]),
                _: 1
            }, 8, ["model-value"]));
        };
    }
});
